<template>
  <div>
    <div>
      <div class="warning-reject-task flex items-center my-8 mx-10">
        <div class="warning-icon flex justify-center items-center mr-6">
          <svg
            width="70"
            height="70"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="35"
              cy="35"
              r="34"
              fill="none"
              stroke="#FB8C00"
              stroke-width="2"
            />
            <path
              d="M34.7873 41.3544C33.8465 41.3544 33.0747 40.5825 33.0747 39.6417V20.7913C33.0747 19.8505 33.8465 19.0787 34.7873 19.0787C35.7281 19.0787 36.4999 19.8505 36.4999 20.7913V39.6417C36.4999 40.5858 35.747 41.3544 34.7873 41.3544Z"
              fill="#FB8C00"
              stroke="#FB8C00"
            />
            <path
              d="M34.7873 46.7818C35.7281 46.7818 36.4999 47.5536 36.4999 48.4944C36.4999 49.4352 35.7281 50.207 34.7873 50.207C33.8465 50.207 33.0747 49.4352 33.0747 48.4944C33.0747 47.5536 33.8465 46.7818 34.7873 46.7818Z"
              fill="#FB8C00"
              stroke="#FB8C00"
            />
          </svg>
        </div>
        <div class="warning-text text-2xl">
          <p v-if="modalRejectMultiple">
            {{
              $t("message.uploadImageComponent.modals.multipleRejectWarning", {
                input: documentsAmount,
              })
            }}
          </p>
          <p v-else>
            {{
              $t("message.uploadImageComponent.modals.individualRejectWarning")
            }}
          </p>
          <p class="font-bold">
            {{
              $t("message.uploadImageComponent.modals.individualRejectWarning2")
            }}
          </p>
        </div>
      </div>
      <div class="text-area m-8 py-3 px-4">
        <textarea
          :value="value"
          @input="updateTextArea"
          ref="rejectIndividualTextArea"
          rows="10"
          cols="50"
          class="text-box"
          maxlength="2500"
          :placeholder="
            modalRejectMultiple
              ? $t(
                  'message.uploadImageComponent.modals.multipleRejectPlaceholderTextArea'
                )
              : $t(
                  'message.uploadImageComponent.modals.individualRejectPlaceholderTextArea'
                )
          "
        ></textarea>
      </div>
    </div>
    <div
      class="zt-modal-footer flex justify-center lg:justify-end items-center p-4"
    >
      <zt-button
        class="ml-1 button-cancel-only-text"
        text
        :disabled="loading"
        @click="$emit('closeRejectModalAndUpdateTasks')"
        >{{ $t("message.uploadImageComponent.modals.buttonCancel") }}</zt-button
      >
      <zt-button
        class="ml-1"
        color="danger"
        @click="$emit('denyLoad')"
        :loader="loading"
        :loaderTxt="
          $t('message.uploadImageComponent.modals.buttonRejectLoading')
        "
        >{{ $t("message.uploadImageComponent.modals.buttonReject") }}</zt-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["value", "modalRejectMultiple", "documentsAmount", "loading"],
  methods: {
    updateTextArea() {
      this.$emit("input", this.$refs.rejectIndividualTextArea.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.warning-reject-task {
  .warning-icon {
    height: 70px;
    width: 70px;
    border: solid 2px #fb8c00;
    border-radius: 50%;
    color: #fb8c00;
    font-size: 40px;

    i {
      margin-bottom: 6px;
      margin-left: 2px;
    }
  }
}

.text-area {
  border: solid 1px #969696;
  border-radius: 4px;

  .text-box {
    width: 100%;
    resize: none;
  }
  .text-box:focus {
    border: none;
    outline: none;
  }
}
</style>
